"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssignTo = void 0;
var _react = require("react");
var _Tooltip = require("../../../../../UI/Tooltip");
var _Select = require("../../../../../UI/Select");
var _TaskManager = require("../../../TaskManager.provider");
var _SectionLabel = require("../SectionLabel");
var _AudiencePicker = require("../../../../AudiencePicker");
var _AssignTo = _interopRequireDefault(require("./AssignTo.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AssignTo = props => {
  const {
    environmentID,
    audiencePickerProvider
  } = props;
  const {
    isMobileView,
    originalTask,
    task,
    setTask,
    setIsChanged,
    getLabel
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const assignToRef = (0, _react.useRef)(null);
  const styles = (0, _AssignTo.default)();
  const assignToOptions = (0, _react.useMemo)(() => {
    return [{
      value: 'all',
      label: getLabel('all_students')
    }, {
      value: 'some',
      label: getLabel('some_students')
    }];
  }, [getLabel]);
  const [selectedOption, setSelectedOption] = (0, _react.useState)();
  const scrollToTop = (0, _react.useCallback)(() => {
    if (assignToRef?.current && task?.assignTo === 'some') {
      assignToRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [task?.assignTo]);
  const handleSelectOption = option => {
    setSelectedOption(option);
    if (option.value !== task.assignTo) {
      setIsChanged(true);
      setTask({
        ...task,
        assignTo: option.value
      });
    }
    scrollToTop();
  };
  (0, _react.useEffect)(() => {
    scrollToTop();
  }, [scrollToTop]);
  (0, _react.useEffect)(() => {
    if (task?.assignTo) {
      const selected = assignToOptions.filter(option => option.value === task.assignTo);
      if (selected && selected[0]) {
        setSelectedOption(selected[0]);
      }
    }
  }, [assignToOptions, task?.assignTo]);
  const selectButton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
    value: selectedOption,
    onChange: handleSelectOption,
    anchorWidth: isMobileView ? 'auto' : 'fit-content',
    btnProps: {
      color: 'basic',
      view: 'outlined',
      customStyle: {
        width: isMobileView ? '100%' : 200
      },
      shape: isMobileView ? 'roundedRectangle' : 'ellipse'
    },
    options: assignToOptions
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__assign-to'],
    ref: assignToRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
      text: getLabel('text_label_associateTo')
    }), environmentID && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-TaskManager__assign-to__select'],
        children: !isMobileView && task?.assignTo === 'some' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
          position: "top",
          anchorWidth: isMobileView ? 'auto' : 'fit-content',
          anchor: selectButton,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: getLabel('some_students_tooltip')
            }
          })
        }) : selectButton
      }), task?.cannotModifyMembers && originalTask?.assignTo === 'all' && task?.assignTo === 'some' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-TaskManager__assign-to__alert'],
        dangerouslySetInnerHTML: {
          __html: getLabel('message_remove_students_from_audience')
        }
      })]
    }), (!environmentID || task?.assignTo === 'some') && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-TaskManager__assign-to__audience'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePicker.AudiencePicker, {
        ...audiencePickerProvider,
        view: "inline"
      })
    })]
  });
};
exports.AssignTo = AssignTo;